import React, { useState, useEffect, createRef } from "react";
import { Container, Row, Col, Stack, Badge } from "react-bootstrap";
import dateFormat from "dateformat";
import Placeholder from 'react-bootstrap/Placeholder';
import Swal from 'sweetalert2'
import { BiBlock } from "react-icons/bi";
import { HiLocationMarker } from "react-icons/hi";
import { TODIS_DROPDOWN } from "../../../components/Forms";
import { TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_DATEPICKER } from "../../../components/Buttons";
import { BsGeoAlt, BsSortDownAlt, BsArrowClockwise, BsCloudSlashFill, BsSortDown, BsCalendarMinusFill, BsPlusLg, BsExclamationCircleFill, BsCheck, BsX , BsBuilding } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AuxiliaryService } from "../../../HttpService/AuxiliaryService";
import 'sweetalert2/src/sweetalert2.scss'
import style from "../Users/Users.module.scss";
import "../../DataCollection/style.css";
import { MdDelete, MdModeEdit, MdVisibility } from "react-icons/md";
import { OrganizationsService } from "../../../HttpService/OrganizationService";
import FormOrganization from "./Form/FormOrganization";

const Organizations = () => {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const formOrg = createRef();
    const navigate = useNavigate();

    const [order, setOrder] = useState(true)
    const [organizations, setOrganizations] = useState([])
    const [response, setResponse] = useState(false)
    const [tasksNotFound, setTasksNotFound] = useState(false)
    const [regionals, setRegionals] = useState([])
    const [filter, setFilter] = useState({})
    const [filterR, setFilterR] = useState({"Regional Partner": [], "Date": null})
    
    const getDataSelect = async() => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/regionalpartner").getAuxiliaries();
    
            auxiliaries.map(item => {
                if(item.txtNameTable == "regionalpartner")
                    setRegionals(item.auxtableDetailsDTOList)
            })
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getOrganizations = async(filter) => {
        try {

            return await new OrganizationsService("organization/organizations/summary").getDataOrganizations(filter);

        } catch (error) {
            console.log("error listing organizations", error);
        }
    }

    const orderRequest = (order) => {
        setOrder(!order)
        setOrganizations(prevState => 
            {
                let newState = [...prevState];
                
                return  newState.sort(function (x, y) {
                    if(order)
                        return y.id - x.id;
                    else
                        return x.id - y.id;
                });
            }
        );
    }
    
    const deleteOrganization = async (id) => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                //showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await new OrganizationsService("organization/organizations/" + id).deleteOrganization();
                    
                    if(res.status == 200){
                        setOrganizations((prevState) => {
                            let newState = [...prevState]
                            newState = newState.filter(item => item.id != id)
                            return newState;
                        })
                        Swal.fire(
                        'Deleted!',
                        'The organization has been deleted.',
                        'success'
                        )
                    }else{
                        console.log("error in delete Organization", res);
                    }
                }
            })
        } catch (error) {
            console.log("error in delete Organization", error);
        }
    }

    const detailOrganization = (id, typeAction) => {
        formOrg.current.detailOrganization(id, typeAction);
    }

    const refreshList = async () => {
        setOrder(true)
        setResponse(false);
        let res = await getOrganizations(null);
            if (res) {
                setOrganizations(prevState => 
                    {                        
                        return  res.sort(function (x, y) {
                            return x.id - y.id;
                        });
                    });
                setResponse(true);
            } else {
                setTasksNotFound(true);
            }
    }

    const handleSelectR = (value, e, name, id) => {
        if(!filterR[name].some(item => item.name == e.target.text)){
            setFilterR(prevState => {
                const newValue = {...prevState};
                newValue[name] = [...newValue[name], {id: value, name: e.target.text}]
                return newValue
            })
            setFilter(prevState => {
                const newValue = {...prevState};
                if(newValue[id] == undefined){
                    newValue[id] = [value]
                }else{
                    newValue[id].push(value)
                }
                return newValue
            })
        }else{
            Toast.fire({
                icon: 'warning',
                title: "Filter by " + name + " <b>" + e.target.text + "</b> is already applied"
              })
        }
    }
    
    const handleDate = (value, name) => {
        setFilterR(prevState => {
            const newValue = {...prevState};
            newValue[name] = value;
            return newValue
        })
        const dateRange = value.split(' ~ ')
        setFilter(prevState => {
            const newValue = {...prevState};
            newValue["fromDate"] = dateFormat(dateRange[0], "dd/mm/yyyy");
            newValue["toDate"] = dateFormat(dateRange[1], "dd/mm/yyyy");
            return newValue
        })
    }

    const removeAllFilterR = () => {
        setFilterR({"Regional Partner": [], "Date": null})
        setFilter({})
    }

    const removeFilterR = (name, id, value) => {
        setFilterR(prevState => {
            const newValue = {...prevState};
            newValue[name] = newValue[name].filter(item => item.id != value)
            //console.log("filter Request", newValue)
            return newValue
        })
        setFilter(prevState => {
            const newValue = {...prevState};
            newValue[id] = newValue[id].filter(item => item != value)
            if(newValue[id].length == 0)
                delete newValue[id]
            return newValue
        })
    }

    const removeFilterDate = (name) => {
        setFilterR(prevState => {
            const newValue = {...prevState};
            newValue[name] = null
            return newValue
        })

        setFilter(prevState => {
            const newValue = {...prevState};
            delete newValue["fromDate"]
            delete newValue["toDate"]
            return newValue
        })
    }

    useEffect(() => {
        (async () => {
            // await getDataSelect();
            setResponse(false);
            let res = await getOrganizations(filter);
            if (res) {
                setOrganizations(prevState => 
                    {                        
                        return  res.sort(function (x, y) {
                            return x.id - y.id;
                        });
                    });
                setResponse(true);
            } else {
                setTasksNotFound(true);
            }
        })();
    }, [filter]);

    useEffect(() => {
        (async () => {
            await getDataSelect();
        })();
    }, []);

    return (
        <>
        <Col sm={8} >
            <Container fluid className="todis-form-wrapper p-4">
                <Row className="pb-3">
                    <Col lg={3} className="ps-4">
                        <Stack gap={0}>
                            <h4 className="todis-header"><BsCalendarMinusFill className="me-3" />Organizations</h4>
                        </Stack>
                    </Col>
                    <Col lg={9}>
                        <Row className="float-end">
                            <Col lg={2} style={{ width: 'auto' }}>
                                <TODIS_DROPDOWN title="Regional Partner" handleSelect={(e, evt) => handleSelectR(e, evt, "Regional Partner", "regionalPartners")} response={response} items={regionals} icon={BsGeoAlt}/> 
                            </Col>
                            {/* <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Date")}/>
                            </Col> */}
                             <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_DATEPICKER handleDate={(data) => handleDate(data, "Date")} placeholder="Date" text="Filter"/>
                            </Col>
                            <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={order ? BsSortDownAlt : BsSortDown} onclick={() => orderRequest(order)}/>
                            </Col>
                            <Col lg={1} style={{ width: 'auto' }}>
                                <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => refreshList()}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12} className="ps-4 pt-4">
                        <Row className="float-start">
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6>
                                    Regional Partner: 
                                    {
                                        filterR["Regional Partner"].length != 0 ?
                                            filterR["Regional Partner"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterR("Regional Partner", "regionalPartners", item.id)}><BsX fontSize={16} color="#3e84b8"/></span> {item.name}</Badge>
                                            })
                                        : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8"/> All Regional Partner</Badge>
                                    }
                                </h6>
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6>
                                    Date: 
                                    {
                                        filterR["Date"] != null ?
                                        <Badge className={style.bgFilter}><span className={style.cursorPointer} onClick={() => removeFilterDate("Date")}><BsX fontSize={16} color="#3e84b8"/></span> {filterR["Date"]}</Badge>
                                        : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8"/> All Date</Badge>
                                    }
                                </h6>
                            </Col>
                            {(filterR["Regional Partner"].length != 0 || filterR["Date"]) &&
                                <Col lg={3} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem", cursor: "pointer" }}><span onClick={() => removeAllFilterR()}><MdDelete size={18} color="red" className="me-1" />Remove Filter</span></h6>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <Row className="todis-form-action-panel pb-3" style={{overflow: "auto", maxHeight: "660px"}}>
                    {
                        !tasksNotFound && response ?
                            (organizations.map((organization, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}>
                            <Container className="ms-2">
                                <Row>
                                    <Col lg={1} className="p-0" style={{width: "min-content"}}> 
                                            <Row className="">
                                                <Col lg={12}>
                                                    <span><BsBuilding size="45" className="me-1" color="#004494" /></span>
                                                </Col>
                                                <Col lg={12} style={{textAlign: "center"}}>
                                                    {/* {organization.regionalPartners.length > 0 ? organization.regionalPartners.map((rp) => (
                                                        <span style={{marginTop: "10px", display: "block", color: "gray"}}>{rp.name}</span>
                                                    )) : null} */}
                                                    {/* <span style={{marginTop: "10px", display: "block", color: "gray"}}>{organization.regionalPartner.regionalPartner}</span> */}
                                                </Col>
                                            </Row> 
                                    </Col>
                                    <Col lg={9}>
                                        <h4 className="fw-bold">{organization.name}</h4>
                                        <Row>
                                            <Col lg={3} className="w-auto">
                                                <span>{organization.description}</span>
                                                <div className="d-flex justify-content-start">
                                                {organization.regionalPartners.length > 0 ? organization.regionalPartners.map((rp) => (
                                                        <div style={{margin: "0.5rem", display: "block", color: "gray"}}><span><HiLocationMarker size="20" className="me-1" color="#004494"/></span>{rp.name}</div>
                                                    )) : null}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col lg={2} className="p-0" style={{alignSelf: "center"}}>
                                        <Row>
                                            <Col lg={4}>
                                                <TODIS_BTN_SECUNDARY variant="primary" icon={MdVisibility} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => detailOrganization(organization.id, "view")}/>
                                            </Col>
                                            <Col lg={4}>
                                                <TODIS_BTN_SECUNDARY variant="primary" icon={MdModeEdit} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => detailOrganization(organization.id, "update")}/>
                                            </Col>
                                            <Col lg={4}>
                                                <TODIS_BTN_PRIMARY variant="primary" icon={MdDelete} sizeIcon="20" style={{fontSize: "12px", padding: "0.7rem 1rem"}} onclick={() => deleteOrganization(organization.id)}/>
                                            </Col>
                                            <Col lg={12} style={{textAlign: "center"}}>
                                                <span style={{marginTop: "10px", display: "block", color: "gray"}}>Create Date: {dateFormat(organization.createdDate, "dd-mm-yyyy")}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>))) : tasksNotFound ?
                                <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                    <h3 className="">Organizations Not found </h3>
                                </div></div> :

                                // loading organizations 
                                ([...Array(5)].map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                    <Row>
                                        <Col lg={1}>
                                            <Placeholder as="h1" animation="glow"><Placeholder xs={8} size="md" /></Placeholder>
                                        </Col>
                                        <Col lg={9}>
                                            <Placeholder as="h4" animation="glow"><Placeholder xs={8} size="md" /></Placeholder>
                                            <Row>
                                                <Col lg={12} >
                                                    <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="lg" /></Placeholder>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={2} className="p-0">
                                            <Row>
                                                <Col lg={4}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                                <Col lg={4}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                                <Col lg={4}>
                                                    <Placeholder.Button variant="light" xs={12} size="md" />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container></Col>)))
                    }
                </Row>
            </Container>
        </Col>
        <Col sm={4}>
            <FormOrganization ref={formOrg} refreshList={refreshList}/>
        </Col>
        </>
    );
}

export default Organizations;